import { IAddToCartLocationAction } from "../interfaces/utils.interface";

export function addToCartLocation(location: string): IAddToCartLocationAction {
  return {
    type: "ADD_TO_CART_LOCATION",
    data: location,
  };
}
